import React from 'react';
import {
    RequirementsHeader,
    RequirementsIcon,
    RequirementsList,
    RequirementsTitle,
} from './ProfilePictureUpload.styles';

/**
 * The "Photo Requirements" list shown alongside the photo-capture options.
 * Shared by the desktop dialog and the Mobile Scanning Page so they can't drift.
 */
function PhotoRequirements() {
    return (
        <>
            <RequirementsHeader>
                <RequirementsIcon>
                    <i className="fal fa-image"></i>
                </RequirementsIcon>
                <RequirementsTitle>Photo Requirements:</RequirementsTitle>
            </RequirementsHeader>
            <RequirementsList>
                <li>Image must be JPEG or PNG</li>
                <li>Supported image file size is up to 10MB</li>
                <li>Please ensure a distance of 40-80cm between your face and the camera</li>
                <li>Be careful not to change your facial expression (smiling face, drawn face, wink, etc.)</li>
                <li>Please ensure that your eyes and eyebrows are uncovered and clearly visible</li>
                <li>Do not wear hats, masks, sunglasses or eyeglasses</li>
                <li>Be careful not to display two faces on the screen</li>
            </RequirementsList>
        </>
    );
}

export default PhotoRequirements;
